export enum TaskStatus {
  Done = 'Done',
  Error = 'Error',
  Aborted = 'Aborted',
  InProgress = 'InProgress',
}

export type TaskError = {
  status: TaskStatus.Error;
  error: string;
};

export type TaskAbort = {
  status: TaskStatus.Aborted;
};

export type Task<TResult> =
  | ({
      status: TaskStatus.Done;
    } & TResult)
  | TaskError
  | TaskAbort;
